/** The labels Compact and Table use, where the full KPI name doesn't fit. */
export const KPI_SHORT_LABELS: Record<string, string> = {
  field_labor_percent: "Field Lab",
  office_labor_percent: "Office Lab",
  gross_margin_percent: "GM",
  net_profit_percent: "NP",
  materials_equipment_percent: "Materials",
  accounts_receivable: "A/R",
  days_sales_outstanding: "DSO",
  days_cash_on_hand: "Cash Days",
  retained_earnings: "Ret. Earn.",
  debt_to_equity: "D/E",
  average_service_ticket: "Svc Ticket",
  average_replacement_ticket: "Repl Ticket",
  field_closing_ratio: "Field Close",
  sales_closing_ratio: "Sales Close",
  call_center_closing_ratio: "Call Book",
};
